export function useFormIkHelper() {
  // Helper function to access nested properties using a path like 'address.city'
  const getValueByPath = (obj, path) => {
    const keys = path.split('.') // Split the path into an array of keys
    return keys.reduce((acc, key) => acc && acc[key], obj) // Traverse the object dynamically
  }

  const validate = async (fields, touchField) => {
    // Validate the fields and get all errors
    const errors = await Promise.all(fields.map((field) => touchField(field))).then(
      (values) => values
    )

    // If there are errors, check if any error corresponds to the provided field paths
    if (errors.length) {
      const error = errors[0]
      const flag = fields.some((field) => {
        // Handle paths dynamically for nested fields
        const fieldError = getValueByPath(error, field)
        return fieldError !== undefined
      })

      if (flag === true) throw new Error('Form is invalid!')
    }

    return errors
  }

  return { validate }
}
